import React, { Fragment, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchConfig, selectConfig } from "../../Store/configSlice";
import { ConsentTypes } from "./Consents";
import Modal from "../Modal/Modal";
import CreditsRemovedConsent from "./Content/CreditsRemovedConsent";
import { useTranslation } from "react-i18next";
import ChangeLogConsent from "./Content/ChangeLog";
import ApiContext from "../../Api/ApiContext";
import { useAuth0 } from "@auth0/auth0-react";
import ContinueButton from "./Components/ContinueButton";
import { AppDispatch } from "../../Store/store";

const Consent: React.FC = () => {

    const config = useSelector(selectConfig);

    const consents: Array<any> = ConsentTypes;
    const consentsGiven: Array<string> = config?.consents || [];

    const consentsNotGiven: Array<string> = consents.filter(consent => {
        const start = new Date(consent.start).getTime();
        const end = new Date(consent.end).getTime();
        const now = new Date().getTime();
        const userCreated = new Date(config?.user?.created).getTime();
        return !consentsGiven?.includes(consent.type) && start < now && end > now && userCreated < start;
    }) || [];

    const ConsentModal = ({consentType}) => {

        const [isOpen, setIsOpen] = useState(true);
        const api = useContext(ApiContext);
        const { getAccessTokenSilently } = useAuth0();
        const dispatch = useDispatch<AppDispatch>();

        const handleSetIsOpen = () => {
            if(isOpen) {
                api.post("/consent/", {type: consentType}).then(() => {
                    getAccessTokenSilently().then(token => {
                        dispatch(fetchConfig(token));
                      });
                });

            }
            setIsOpen(!isOpen);
        }

        const { t } = useTranslation();

        let title = "";
        let content = <></>;

        switch (consentType) {
            case "CreditsRemoved":
                title = t('consent.creditsRemoved.title')
                content = <CreditsRemovedConsent />;
                break;
            case "ChangeLog":
                title = t('consent.changeLog.title')
                content = <ChangeLogConsent />;
                break;
            default:
                break;
        }

        return (
            <Modal
                showModal={isOpen}
                setShowModal={handleSetIsOpen}
                title={title}
                content={<>{content}<ContinueButton close={handleSetIsOpen} /></>}
                confetti={true}
                minWidth="500px"
            />
        )
    };

    if(!config || !consentsNotGiven.length) return null;

    return (
        <>
            {consentsNotGiven.map((consentType: any) => {
                if (consentType.modalType !== "consent") return <Fragment />;
                return <ConsentModal key={consentType} consentType={consentType.type} />;
            })}
        </>
    );
};

export default Consent;